// src/components/sections/HomeBlogsPreview.jsx
import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion, useInView } from 'framer-motion'
import { useAppSelector, useAppDispatch } from '../../hooks/useAppDispatch.js'
import './HomeBlogsPreview.scss'
import { fetchBlogs } from '../../redux/slices/blogsSlice.js'

//assets images 
import blog1 from '../../assets/Images/Home/Blogs/one.png'
import blog2 from '../../assets/Images/Home/Blogs/two.png'
import blog3 from '../../assets/Images/Home/Blogs/three.png'

// Static data 
const STATIC_BLOGS = [
    {
        id: 1,
        title: 'THE ULTIMATE GUIDE TO BLUETOOTH CLASSIC PROFILES: NAVIGATING THE CONFUSION',
        category: 'Artificial intelligence',
        imageUrl: blog1,
        slug: 'the-ultimate-guide-to-bluetooth-classic-profiles-navigating-the-confusion'
    },
    {
        id: 2,
        title: '5 COMPELLING REASONS WHY YOUR COMPANY SHOULD EMBRACE MICRONAUT',
        category: 'Artificial intelligence',
        imageUrl: blog2,
        slug: '5-compelling-reasons-why-your-company-should-embrace-micronaut'
    },
    {
        id: 3,
        title: 'A COMPREHENSIVE COMPARISON: NRF52 SERIES VS. NRF90 SERIES FOR YOUR IOT PROJECTS',
        category: 'IT Company',
        imageUrl: blog3,
        slug: 'a-comprehensive-comparison-nrf52-series-vs-nrf90-series-for-your-iot-projects'
    }
]

export default function HomeBlogsPreview() {
    const ref = useRef(null)
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const isInView = useInView(ref, { once: true, margin: '-100px' })

    const displayBlogs = STATIC_BLOGS

    // Animation variants
    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
        },
    }

    const item = {
        hidden: { y: 30, opacity: 0 },
        show: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.5, ease: 'easeOut' },
        },
    }

    return (
        <section className="home-blogs-preview" ref={ref}>
            <div className="container-custom">
                {/* Heading */}
                <div className="section-header">
                    <h2 className="title">
                        Dive into the <br />
                        <span className="highlight-text">Latest Trends in Our Blog</span>
                    </h2>
                </div>

                {/* Grid */}
                <motion.div
                    className="blogs-grid"
                    variants={container}
                    initial="hidden"
                    animate={isInView ? 'show' : 'hidden'}
                >
                    {displayBlogs.map((blog, index) => (
                        <motion.div
                            key={index}
                            className="blog-card"
                            variants={item}
                            whileHover={{ y: -5, transition: { duration: 0.2 } }}
                        >
                            {/* Image Container */}
                            <div className="card-image-wrapper">
                                <img
                                    src={blog.imageUrl || blog.image}
                                    alt={blog.title}
                                />
                                {/* Floating Badge */}
                                <div className="category-badge">
                                    {blog.category || 'Technology'}
                                </div>
                            </div>

                            {/* Content */}
                            <div className="card-content">
                                <h3 className="blog-title">{blog.title}</h3>

                                <button
                                    className="read-more-link"
                                    onClick={() => navigate(`/blog/${blog.slug}`)}
                                >
                                    Read More
                                </button>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    )
}
